export default __webpack_public_path__ + "static/designer-dock-b8e6c2973aba3d20e9b3c656f53e5ed9.png";